export default __webpack_public_path__ + "static/media/home-book.9189db65.jpg";